<div *ngIf="formVariant" [formGroup]="formVariant">
  <div class="container">
    <div *ngIf="applianceGroupsRefData" class="row-element space-h-m appliance-group">
      <div class="title">
        <h1 class="title-text">
          {{ 'APPLIANCE_GROUPS' | translate }}
        </h1>
      </div>
      <dcp-appliance-groups-control
        [appliancesAddButtonIdTag]="'RecipesModifyStepsAppGroupAddAllBtn'"
        *ngIf="formVariant?.controls?.defaultApplianceGroup && formVariant?.controls?.applianceGroups"
        [allApplianceGroups$]="applianceGroupsList$"
        [defaultApplianceGroupCtrl]="formVariant.controls.defaultApplianceGroup"
        [listOfApplianceGroupsCtrl]="formVariant.controls.applianceGroups"
        [defaultTranslation]="'DEFAULT' | translate"
      ></dcp-appliance-groups-control>
    </div>

    <div *ngIf="kitchenwaresList" class="row-element space-h-m accessory">
      <div class="title">
        <h1 class="title-text">
          {{ 'KITCHENWARE' | translate }}
        </h1>
      </div>
      <app-form-field-select-autocomplete
        [autoSelectIdTag]="'RecipesModifyStepsAccessoryBtn'"
        [autoSelectListIdTag]="'RecipesModifyStepsAccessoryLst'"
        [autoSelectLabelIdTag]="'RecipesModifyStepsAccessoryLbl'"
        [autoSelectRemoveBtnIdTag]="'RecipesModifyStepsAccessoryRemoveBtn'"
        class="form-field-xl margin-input"
        [label]="'KITCHENWARE'"
        [showBracket]="false"
        [control]="formVariant.controls.kitchenwares"
        [useKeyAndName]="true"
        [completeList]="kitchenwaresList"
        appearance="fill"
      ></app-form-field-select-autocomplete>
    </div>

    <div *ngIf="utensilList" class="row-element space-h-m utensil">
      <div class="title">
        <h1 class="title-text">
          {{ 'USTENSILS' | translate }}
        </h1>
      </div>
      <dcp-utensils-group-control
        *ngIf="formVariant?.controls?.utensils"
        [allUtensils$]="utensilsList$"
        [listOfUtensilsCtrl]="formVariant.controls.utensils"
      ></dcp-utensils-group-control>
    </div>

    <div *ngIf="domain === 'PRO_AUT'" class="row-element space-h-m">
      <div class="title">
        <h1 class="title-text">
          {{ 'MIN_CAPACITY' | translate }}
        </h1>
      </div>
      <mat-form-field appearance="fill" class="form-field-maxi field-quantity form-field-no-header form-field-number">
        <input matInput type="number" formControlName="applianceMinimumVolume" min="0" step="0.1" />
      </mat-form-field>
    </div>
    <div class="tips-and-time">
      <h2>{{ 'TIMES' | translate }}</h2>
      <app-time-inputs
        [formVariant]="formVariant"
        [applianceGroupsList]="applianceGroupsList"
        [updateComponent]="updateTimesInputs"
      ></app-time-inputs>

      <div class="steps-header">
        <h2>{{ 'VARIANTS.STEPS.STEPS_INSTRUCTIONS' | translate }}</h2>
      </div>
      <ng-container *ngIf="showBlockInputInstruction && formSteps?.length === 0">
        <mat-form-field class="form-field-maxi margin-input space-h-l" appearance="fill">
          <mat-label>{{ 'INSTRUCTIONS' | translate }}</mat-label>
          <textarea matInput rows="8" [(ngModel)]="textareaInputInstruction" [ngModelOptions]="{ standalone: true }"></textarea>
          <mat-hint>
            <mat-icon aria-hidden="false" aria-label="info icon" class="space-h-s">info</mat-icon>
            {{ 'STEPS_WIZARD_INST_1' | translate }}
          </mat-hint>
        </mat-form-field>
        <button
          mat-button
          class="btn btn-submit right"
          id="RecipeModifyStepAddStepBtn"
          (click)="blockInputInstruction(textareaInputInstruction)"
        >
          {{ 'STEPS_BLOCK_BTN' | translate }}
        </button>
      </ng-container>
      <ng-container *ngIf="!showBlockInputInstruction || (formSteps?.length || 0) > 0">
        <app-steps-block
          [variant]="variant"
          [formArray]="formSteps"
          [formVariant]="formVariant"
          [slideshows]="slideshows"
          [utensilDataref]="filteredUtensils"
          [kitchenwaresDataref]="kitchenwaresList"
          [techniqueDataref]="techniqueList"
          [stepTypesDataref]="stepTypes"
          [programList]="programList"
          [applianceGroupsList]="applianceGroupsList"
          [parameterSettingsList]="parameterSettingsList"
          [psNamesList]="psNamesList"
          [domain]="domain"
          [lang]="lang"
          [market]="market"
          (addLine)="addLine($event)"
        ></app-steps-block>
        <div class="divider">
          <mat-divider></mat-divider>
        </div>
      </ng-container>

      <h2 class="space-v-l">{{ 'TIPS' | translate }}</h2>
      <mat-form-field class="form-field-maxi margin-input space-h-l" appearance="fill">
        <mat-label>{{ 'TIPS' | translate }}</mat-label>
        <textarea id="RecipesModifyStepsAdviceTxt" matInput formControlName="tips"></textarea>
      </mat-form-field>
    </div>
  </div>
</div>
